import React, { Component } from 'react'
import {Rectangle, Circle, Ellipse, Polyline, CornerBox, Triangle} from 'react-shapes';
import Typography from '@material-ui/core/Typography';
import setting from '../../config/setting'

class RRRatingSquare extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value:0,
        }
    }
	render() {
		if (this.props.type=='current') {
			return(
				<div style={{position:'relative'}}>
        	    	<Typography style={{position:'absolute', color:'white', fontSize:'15px', left:this.props.name == 'High' ? '25px' : this.props.name == 'Low' ? '27px' : '15px', top:'22px'}} >{this.props.name}</Typography>
        	    	<Rectangle
                        width={80}
                        height={60}
                        fill={{ color:this.props.name == 'High' ? setting.COLOR.RED : this.props.name == 'Medium' ? setting.COLOR.AMBER : setting.COLOR.GREEN}}
                        stroke={{ color:setting.COLOR.LIGHT_BLUE}} 
                        strokeWidth={4} 
                    />
        		</div>
			)
		} else {
			return (
        		<div style={{position:'relative'}}>
        		    <Typography style={{position:'absolute', color:'white', fontSize:'15px', left:this.props.name == 'High' ? '25px' : '13px', top:'5px'}} >{this.props.name}</Typography>
        		    <Rectangle
                        width={80}
                        height={30}
                        fill={{color:this.props.name == 'High' ? setting.COLOR.RED : this.props.name == 'Medium' ? setting.COLOR.AMBER : setting.COLOR.GREEN}}
                        strokeWidth={0} 
                    />
        		</div>
        	)
		}
    }
}
export default RRRatingSquare;


// WEBPACK FOOTER //
// ./src/components/SharedComponents/RRRatingSquare.js